import { BREAKPOINTS } from '@repo/ui/queries';
import { buildImageProxyUrl } from '@repo/utils/url';

import { PresetGroup } from 'components/BackgroundReplacer/Scene/types';
import { ScenesGroup } from 'global/types/Generators';
import {
  canBeInProgress,
  hasInitialImage,
  imageCanBeEdited,
  WorkflowState,
} from 'stores/backgroundReplacerStore/types';

export const getGeneratingButtonLabel = (state: WorkflowState): string => {
  if (!hasInitialImage(state)) {
    return 'Generate Background';
  }

  if (!imageCanBeEdited(state)) {
    return 'Removing Background';
  }

  if (canBeInProgress(state) && state.inProgress) {
    return 'Generating Background';
  }

  return 'Generate Background';
};

export const getItemsPerPage = (windowSize: number | undefined): number => {
  if (!windowSize || windowSize >= BREAKPOINTS.tabletMin) {
    return 12;
  }
  return 10;
};

export const toPresets = (sceneGroups: ScenesGroup[]): PresetGroup[] => {
  const filtered = sceneGroups.filter((group) => !!group.scenes?.length);
  return filtered.map((group) => ({
    id: group.id,
    label: group.name,
    presets: group.scenes!.map((scene) => ({
      id: scene.id,
      label: scene.name,
      imageSrc: buildImageProxyUrl(`api/${scene.preview}`),
    })),
  }));
};
